import { useCachedApi } from '../../hooks/useCachedApi';
import styles from './ConfigPanel.module.css';

const ConfigPanel = ({ config, setConfig }) => {
  const { data: options, loading: optionsLoading } = useCachedApi(
    '/v1/personas/config/options',
    600000
  );

  const handleConfigChange = (e) => {
    const { name, value } = e.target;
    setConfig((prevConfig) => ({
      ...prevConfig,
      [name]: value,
    }));
  };

  const handleConstraintChange = (e) => {
    const { value } = e.target;
    setConfig((prevConfig) => ({
      ...prevConfig,
      responseConstraints: value ? [value] : [],
    }));
  };

  return (
    <div className={styles.configPanel}>
      <h2>
        <i className="fas fa-sliders-h" style={{ marginRight: '10px' }}></i>{' '}
        Customization
      </h2>

      <fieldset className={styles.configGroup}>
        <legend>Verbosity</legend>
        <div className={styles.radioGroup}>
          <label>
            <input
              type="radio"
              name="verbosity"
              value="brief"
              checked={config.verbosity === 'brief'}
              onChange={handleConfigChange}
            />
            Brief
          </label>
          <label>
            <input
              type="radio"
              name="verbosity"
              value="normal"
              checked={config.verbosity === 'normal'}
              onChange={handleConfigChange}
            />
            Normal
          </label>
          <label>
            <input
              type="radio"
              name="verbosity"
              value="detailed"
              checked={config.verbosity === 'detailed'}
              onChange={handleConfigChange}
            />
            Detailed
          </label>
        </div>
      </fieldset>

      <fieldset className={styles.configGroup}>
        <legend>Tone</legend>
        <div className={styles.radioGroup}>
          {optionsLoading ? (
            <p>Loading options...</p>
          ) : (
            options?.toneLevels?.map((level) => (
              <label key={level}>
                <input
                  type="radio"
                  name="tone"
                  value={level}
                  checked={config.tone === level}
                  onChange={handleConfigChange}
                />
                {level.charAt(0).toUpperCase() + level.slice(1)}
              </label>
            ))
          )}
        </div>
      </fieldset>

      <fieldset className={styles.configGroup}>
        <legend>Emotional State (Override)</legend>
        <input
          type="text"
          name="emotionalState"
          value={config.emotionalState}
          onChange={handleConfigChange}
          placeholder="e.g., joyful, angry, curious"
        />
      </fieldset>

      <fieldset className={styles.configGroup}>
        <legend>Response Constraint (1 max)</legend>
        <input
          type="text"
          name="responseConstraints"
          value={config.responseConstraints[0] || ''}
          onChange={handleConstraintChange}
          placeholder="e.g., End with a question"
        />
      </fieldset>
    </div>
  );
};

export default ConfigPanel;
